<template>
  <div class="deposit_pages boxCore" id="order_future">
    <div class="d-flex w-100">
      <div class="filter-template">
        <div class='label-text'>{{ $t('funds.balances.from') }}</div>
        <date-picker :disabled="disabledDatesFrom" v-model="startDate" class="date-picker-input" :format="customFormatter"></date-picker>
      </div>
      <div class="filter-template">
        <div class='label-text'>{{ $t('funds.history.to') }}</div>
        <date-picker :disabled="disabledDatesTo" v-model="endDate" class="date-picker-input" :format="customFormatter"></date-picker>
      </div>

      <div class="filter-template">
        <div class="label-text">&nbsp;</div>
<!--        <input-->
<!--            title-->
<!--            type="text"-->
<!--            :placeholder="'Search by symbol'"-->
<!--            @keyup.enter="search"-->
<!--            class="form-control search_symbol"-->
<!--            name="searchKey"-->
<!--            v-model="filters.searchKey"-->
<!--        >-->
        <select-box4
            v-model="filters.searchKey"
            @keyup.enter="search"
            :placeholder="'Search by symbol'"
            @input="selectedCoin($event)"
            :options="dataOption"
        />
      </div>
      <div class="filter-template">
        <div class="label-text">&nbsp;</div>
        <button class="btn btn-reset btn-search" @click="search()">{{ $t('orders.open_order.search') }}</button>
        <button class="btn btn-reset" @click="refresh()">{{ $t('orders.open_order.reset') }}</button>
      </div>
    </div>

    <div class="table-futures">
      <data-table-futures :getData="getOrderFutureRecords" ref="datatable" :column="12" :limit="10" :inLine="true" class="scroll" :total-user="totalRecords">
        <th class="text-left" data-sort-field="time">{{ $t('usd_transaction.time') }}</th>
        <th class="text-left" data-sort-field="symbol">Symbol</th>
        <th class="text-left" data-sort-field="buy_owner_email">{{ $t('margin.orders.trade_history.buy_owner_email') }}</th>
        <th class="text-left" data-sort-field="sell_owner_email">{{ $t('margin.orders.trade_history.sell_owner_email') }}</th>
        <th class="text-left" data-sort-field="buy_fee">{{ $t('orders.trade_history.buy_fee') }}</th>
        <th class="text-left" data-sort-field="sell_fee">{{ $t('orders.trade_history.sell_fee') }}</th>
        <th class="text-left" data-sort-field="price">{{ $t('exchange.basic.chart.price') }}</th>
        <th class="text-left" data-sort-field="quantity">{{ $t('emails.withdraw_verify.line_4') }}</th>

        <template slot="body" slot-scope="props">
          <tr>
            <td class="text-left" >
              <div class="text-top">{{ props.item.createdAt | dateFormat2 }} </div>
              <div class="text-bottom">{{ props.item.createdAt | timeFormat2 }}</div>
            </td>
            <td class="text-left">
              <div class="text-top">{{ props.item.name }} </div>
              <div class="text-bottom">{{'Perpetual'}}</div>
            </td>
            <td class="text-left">
              {{props.item?.buyEmail}}
            </td>
            <td class="text-left">
              {{props.item?.sellEmail}}
            </td>
            <td class="text-left">
              {{props.item.buyFee | showMax8NumbersWithCommas}}
            </td>
            <td class="text-left" >
              {{props.item.sellFee | showMax8NumbersWithCommas}}
            </td>
            <td class="text-left" >
              {{props.item.price| showMax8NumbersWithCommas }}
            </td>
            <td class="text-left" >
              {{props.item.quantity | formatCurrencyAmountDecimal(2, '0')}}
            </td>
          </tr>
        </template>
      </data-table-futures>
    </div>

    <div class="clearfix clearfix-40"></div>
  </div>
</template>


<script>
import Modal from "../../components/Modal";
import DatePicker from "vuejs-datepicker";
import SelectBox from "../../components/SelectBox";
import moment from "moment";
import rf from "../../lib/RequestFactory";
import SelectBox4 from "@/components/SelectBox4.vue";

export default {
  name: "TradeFuturesRecords",
  components: {
    SelectBox4,
    Modal,
    DatePicker,
    SelectBox
  },
  data() {
    return {
      titlePage: 'Trade History',
      searchKey: '',
      startDate: moment().subtract(1, 'week').toDate(),
      endDate: moment().toDate(),
      filters: {
        searchKey: ""
      },
      isLoading: false,
      TypesData: [
        {name: 'Limit', value: 'LIMIT'},
        {name: 'Market', value: 'MARKET'},
        {name: 'Stop Limit', value: 'STOP_LIMIT'},
        {name: 'Stop Market', value: 'STOP_MARKET'},
        {name: 'Trailing Stop', value: 'trailing_stop'},
        {name: 'Liquidation', value: 'liquidation'},
      ],
      isShowSideOptions: false,
      isShowTypeOptions: false,
      totalRecords: 0,
      dataOption: []
    }
  },
  computed: {
    disabledDatesFrom() {
      return {
        from: new Date(), // Disable all dates in the future
      };
    },
    disabledDatesTo(){
      return {
        from: new Date(),
        to: new Date(this.startDate)
      };
    }
  },
  methods: {
    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    selectedCoin(e){
      this.filters.searchKey = e
    },
    search() {
      let filterParams = {
        from: moment(this.startDate)
            .startOf("day")
            .format('YYYY-MM-DD'),
        to: moment(this.endDate)
            .endOf("day")
            .format('YYYY-MM-DD')
      };
      if (this.customFormatter(this.startDate) > this.customFormatter(this.endDate)) {
        this.$toastr("error", this.$t("common.date.warning"));
        return;
      }
      if (this.filters.searchKey) {
        filterParams.search_key = this.filters.searchKey;
      }
      this.$refs.datatable.filter(filterParams);
    },
    refresh() {
      this.resetInput();
      this.$refs.datatable.refresh();
    },
    resetInput() {
      this.filters = Object.assign(this.filters, {
        searchKey: ""
      });
      this.startDate = moment().subtract(1, 'week').toDate();
      this.endDate = moment().toDate();
      $(".datatable").find("th").attr("data-sort-order", "");
    },
    listenForNotification() {
      window.Echo.channel('App.Models.Admin')
          .listen('AdminNotificationUpdated', () => {
            this.$refs.datatable.refresh();
          });
    },
    getOrderFutureRecords(params) {
      let meta = {
        from: this.customFormatter(this.startDate),
        to: this.customFormatter(this.endDate)
      };
      if (this.filters.searchKey) {
        meta.symbol = this.filters.searchKey;
      }
      params = Object.assign(params, meta);
      params.size = params.limit || 5;
      delete params.limit;
      const records = rf.getRequest('AdminRequest').getTradeFutureRecords(params);
      records.then(data => {
        this.totalRecords = data.metadata.total;
      })
      return records;
    },
  },
  mounted() {
    this.$emit('EVENT_PAGE_CHANGE', this);
    this.listenForNotification();

  },
  created(){
    rf.getRequest('AdminRequest').getAsset().then(res =>{
      this.dataOption = res.data
    })
  }
}
</script>


<style lang="scss" scoped>
@import "@/assets/sass/variables";
.d-flex {
  display: flex;
}
.w-100 {
  width: 100%;
}
.buy {
  color: $text-color-jade!important;
}
.sell {
  color: $text-color-red!important;
}
#order_future {
  table {
    thead {
      th {
        &:first-child {
          width: 12%;
          min-width: 130px;
        }
        &:nth-child(2) {
          width: 11%;
          min-width: 120px;
        }
        &:nth-child(3) {
          width: 18%;
          min-width: 200px;
        }
        &:nth-child(4) {
          width: 18%;
          min-width: 200px;
        }
        &:nth-child(5) {
          width: 12%;
          min-width: 130px;
        }
        &:nth-child(6) {
          width: 12%;
          min-width: 130px;
        }
        &:nth-child(7) {
          width: 11%;
          min-width: 120px;
        }
        &:nth-child(8) {
          width: 8%;
          min-width: 90px;
        }
      }
    }
  }
}

.no-left-radius {
  input {
    border-radius: 0px 3px 3px 0px;
  }
}
.no-right-radius {
  input {
    border-radius: 3px 0px 0px 3px;
  }
}
td{
  word-break: break-all;
}
.datatable{
  font-family: $mulish-regular !important;
}

ul {
  list-style-type: none;
  padding: 0px;
}
.clearfix-40 {
  display: block;
  clear: both;
  height: 40px;
}
.deposit_pages {
  font-family: $mulish-regular;
  .filter_container {
    margin: 12px 0px;
    .title_item {
      color: $color_mine_shaft;
      font-size: $font_big_20;
      font-weight: 500;
      line-height: 28px;
      float: left;
    }
    .search_box {
      display: inline-block;
      float: right;
      width: 215px;
      max-width: 100%;
      .search_input {
        background-color: transparent;
        height: 28px;
        border: 1px solid $color_alto;
        padding: 4px 15px;
        line-height: 20px;
        width: 100%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: $font-small;
      }
    }
  }
  .item_email_user {
    display: inline-block;
    float: left;
    position: relative;
    .txt_email_user {
      display: block;
      max-width: 170px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .tooltip_email_user {
      position: absolute;
      top: 0px;
      left: 0px;
      line-height: 20px;
      padding: 5px 20px;
      left: 100%;
      background-color: $color_white;
      white-space: nowrap;
      width: auto;
      z-index: 10;
      font-size: $font_root;
      font-weight: 500;
      color: $color_mine_shaft;
      transition: 0.5s;
      display: none;
      box-shadow: 1px 1px 15px rgba(0, 0, 0, 0.4);
      &:after {
        right: 100%;
        top: 50%;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-color: rgba(136, 183, 213, 0);
        border-right-color: $color_white;
        border-width: 5px;
        margin-top: -5px;
      }
    }
    &:hover {
      .tooltip_email_user {
        display: block;
        transition: 0.5s;
      }
    }
  }
  .item_bank_user {
    display: inline-block;
    float: left;
    position: relative;
    .txt_bank_user {
      display: block;
      max-width: 250px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .tooltip_bank_user {
      position: absolute;
      top: 0px;
      left: 0px;
      line-height: 20px;
      padding: 5px 20px;
      left: 100%;
      background-color: $color_white;
      // white-space: nowrap;
      width: 250px;
      z-index: 10;
      font-size: $font_root;
      font-weight: 500;
      color: $color_mine_shaft;
      transition: 0.5s;
      display: none;
      box-shadow: 1px 1px 15px rgba(0, 0, 0, 0.4);
      &:after {
        right: 100%;
        top: 12px;
        border: solid transparent;
        content: " ";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
        border-color: rgba(136, 183, 213, 0);
        border-right-color: $color_white;
        border-width: 5px;
        margin-top: -5px;
      }
    }
    &:hover {
      .tooltip_bank_user {
        display: block;
        transition: 0.5s;
      }
    }
  }
  .btn_Confirm,
  .btn_Reject {
    background-color: $color-caribbean-green;
    color: $color-white;
    text-transform: uppercase;
    width: 82px;
    height: 25px;
    line-height: 20px;
    padding: 0px 9px;
    text-align: center;
    font-size: $font-smaller;
    font-family: $mulish-extra-bold;
    border: 1px solid $color-caribbean-green;
    border-radius: 3px;
    transition: 0.5s;
    &:hover {
      background-color: $color-aquamarine;
      border-color: $color-aquamarine;
      transition: 0.5s;
    }
  }
  .btn_Reject {
    margin-left: 10px;
  }
  .list_modal_deposit {
    margin-bottom: 25px;
    padding: 0px;
    li {
      line-height: 20px;
      margin-bottom: 10px;
      color: $color_dove_gray;
      font-size: $font_root;
      font-weight: 500;
      .text-right {
        font-weight: 600;
        color: $color_mine_shaft;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .content_modal_deposit {
    color: $color_mine_shaft;
    font-size: $font_semi_big;
    font-family: $mulish-regular;
    font-weight: 500;
    text-align: center;
    line-height: 24px;
  }
}
.select_transaction_container {
  padding: 10px 0px 20px 0px;
  .input-radio {
    label {
      display: inline;
      font-weight: normal;
      text-align: center;
      margin-right: 25px;
      span {
        font-size: $font_big;
      }
      input[type="radio"] {
        display: inline-block;
        margin-top: 0px;
        position: relative;
        top: -2px;
      }
    }
  }
}
.filter-container {
  margin: 10px 0 30px 0px;
  height: 60px;
  .filter-item {
    .label-text {
      font-size: $font-small;
      color: $color-grey-dusty;
      padding-bottom: 4px;
    }
    float: left;
    margin: 0px;
    margin-right: 20px;
    input {
      background-color: $color-white-smoke;
      margin-top: 22px;
      display: inline-block;
      width: 145px;
    }
    select {
      width: 65px;
      display: inline-block;
    }
    button {
      margin: 0 5px;
      width: auto;
      margin-top: 22px;
      height: 30px;
      font-size: 13px;
    }
    .btn-search, .btn-reset {
      font-size: $font-smaller;
      font-family: $mulish-extra-bold;
      border-radius: 3px;
      border: 1px solid $color-caribbean-green;
      width: 85px;
      color: $color_white;
      text-transform: uppercase;
      background-color: $color-caribbean-green;
      &:hover {
        background-color: $color-aquamarine;
        border-color: $color-aquamarine;
        transition: 0.5s;
      }
    }
  }
  .btn-action {
    margin-left: -10px;
  }
}
.form-control {
  background: $color_concrete;
  height: 30px;
  font-size: $font-small;
  padding-left: 11px;
  padding-right: 0;
  &:hover, &:focus {
    border-color: $color-jungle-green;
  }
}
.datatable {
  button.btnForm.bt-action {
    padding-left: 5px !important;
    padding-right: 5px !important;
    font-weight: 400 !important;
  }
}
.buy {
  color: $text-color-jade;
}
.sell {
  color: $text-color-red;
}
.toolbar-element2 {
  display: inline-block;
  float: left;
  width: 65px;
}
td {
  font-family: $mulish-regular;
}
.table-futures {
  margin-top: 24px;
}
.filter-template {
  margin-right: 15px;
  .label-text {
    color: $dark-1;
    font-weight: 500;
    font-size: 14px;
    margin-bottom: 7px;
  }
  .date-picker-input {
    display: inline-block;
    float: left;
    ::v-deep{
      input {
        padding: 0 5px 0px 36px;
        width: 135px !important;
        height: 32px;
        border: 1px solid #C7CBD3!important;
        border-radius: 10px!important;
        background-image: url('@/assets/images/icon/date-time.svg') !important;
        background-color: $color-white-smoke !important;
        background-size: 12px !important;
        background-position: center left 12px !important;
        background-repeat: no-repeat !important;
        color: $dark-1;
        &:hover, &:active, &:focus {
          border-color: $color-jungle-green;
          z-index: 9;
        }
      }
    }

  }
  .btn-reset {
    background: $color-caribbean-green;
    border-radius: 30px;
    color: $color_mine_shaft;
    font-weight: 700;
    width: 78px;
    height: 32px;
  }
  .btn-search {
    margin-right: 10px;
  }
  .search_symbol {
    background: $color-white;
    border: 1px solid #C7CBD3!important;
    border-radius: 10px!important;
    width: 197px;
    height: 32px;
  }
}
.tab-header {
  display: block;
  width: 100%;
  float: left;
  margin: 10px 0px 23px 0px;
  ul {
    list-style: none;
    padding-left: 0px;
    li {
      float: left;
      margin-right: 25px;
      font-size: $font_big;
      color: $color-grey-dark;
      display: block;
      >a {
        color: $color-grey-dark;
        font-family: $mulish-regular;
        font-weight: 500;
        font-size: $font_big;
        display: block;
        float: right;
        &::before {
          content: "";
          display: inline-block;
          width: 12px;
          height: 12px;
          border-radius: 50%;
          border: solid 1px #979797;
        }
        span {
          padding-left: 5px;
        }
      }
      &.active {
        >a {
          &::before {
            border: solid 4px $color-jungle-green;
          }
          color: $color-jungle-green;
        }
      }
    }
  }
}
.input-dropdown {
  position: relative;
  input {
    background: $color-white;
    border: 1px solid #C7CBD3!important;
    border-radius: 10px!important;
    width: 110px;
    height: 32px;
  }
  .icon-coin-input {
    position: absolute;
    left: 50px;
    top: 50%;
    transform:translateY(-50%);
    cursor: pointer;
    color:#667186;
    i {
      font-size: 22px;
    }
  }
  .coin-option {
    position: absolute;
    top: 37px;
    width: 100%;
    background: #FFFFFF;
    box-shadow: 0px 4px 15px rgba(0, 19, 54, 0.15);
    border-radius: 10px;
    padding: 17px 0;
    z-index: 3;
    &:after {
      bottom: 100%;
      left: 50%;
      border: solid transparent;
      content: " ";
      display: block;
      height: 0;
      width: 0;
      position: absolute;
      pointer-events: none;
      border-color: rgba(136, 183, 213, 0);
      border-bottom-color: $color-white;
      border-width: 5px;
      margin-left: -5px;
    }
    .option {
      display: flex;
      align-items: center;
      width: 100%;
      line-height: normal;
      cursor: pointer;
      padding-left: 14px;
      font-size: 14px;
      font-weight: 500;
      overflow: hidden;
      color: #001336;
      height: 32px;

      &:hover {
        background: $color-athens;
      }
    }
  }
}
</style>

<style lang="scss">
@import "@/assets/sass/variables";
#deposit_fiat_pages {
  .sc_search_select {
    .group_search_select {
      .button_drop_search {
        width: 55px;
        height: 30px !important;
        padding: 5px 10px 5px 10px !important;
        border-radius: 3px;
        margin-right: 20px;
        font-size: $font-small;
        font-family: $mulish-regular;
        i.icon-arrow1 {
          margin-left: 5px;
          color: $color_dove_gray;
        }
        &:hover {
          border-color: $color-jungle-green;
          i.icon-arrow1 {
            color: $color-jungle-green;
          }
        }

      }
      .box_list_search_select {
        .list_search_select {
          li {
            font-family: $mulish-regular;
            font-size: $font-small;
            &:hover, &:active, &:focus {
              color: $color-jungle-green;
            }
          }
        }
      }
    }
  }
}
</style>
